import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DownloadIcon from "@mui/icons-material/Download";

import { useApiClient } from "@/hooks/useApiClient";
import { getOwnerAnalyzeFileApi } from "@/features/ownerInfo/api";
import { toast } from "react-toastify";
import { type OwnerAnalyzeFileDownloadRequest } from "@/features/ownerInfo/types";
import { DmMaxBranchNumberModal } from "@/features/ownerInfo/components/DmMaxBranchNumberModal";

interface OutputMenuProps {
  disabled: boolean;
  requestId: number;
}

export default function OutputMenu({
  disabled,
  requestId,
}: OutputMenuProps): React.ReactElement {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const [openDmMaxBranchNumberModal, setOpenDmMaxBranchNumberModal] =
    React.useState(false);
  const [realEstateOwnerAnalyzeRequestId, setRealEstateOwnerAnalyzeRequestId] =
    React.useState<number>(NaN);

  const { apiClient } = useApiClient();

  const buttonClickHandler = ({
    requestId,
    resType,
    fallBackName,
  }: OwnerAnalyzeFileDownloadRequest): void => {
    if (resType === "excel_direct_mail") {
      setRealEstateOwnerAnalyzeRequestId(requestId);
      setOpenDmMaxBranchNumberModal(true);
    } else {
      try {
        getOwnerAnalyzeFileApi(apiClient, {
          requestId,
          resType,
          fallBackName,
        });
      } catch (error) {
        toast.error("ファイルのダウンロードに失敗しました");
      }
    }
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        disabled={disabled}
        variant="outlined"
        color="primary"
        id="output-button"
        aria-controls={open ? "output-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        出力
        <DownloadIcon />
      </Button>
      <Menu
        id="output-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "output-button",
        }}
      >
        <MenuItem
          onClick={() => {
            buttonClickHandler({
              requestId,
              resType: "excel",
              fallBackName: `所有者事項解析結果_${requestId}.xlsx`,
            });
            handleClose();
          }}
        >
          エクセルダウンロード
        </MenuItem>
        <MenuItem
          onClick={() => {
            buttonClickHandler({
              requestId,
              resType: "excel_design",
              fallBackName: `【色付き】所有者事項解析結果_${requestId}.xlsx`,
            });
            handleClose();
          }}
        >
          エクセルダウンロード（色付き）
        </MenuItem>
        <MenuItem
          onClick={() => {
            buttonClickHandler({
              requestId,
              resType: "csv_owners",
              fallBackName: `所有者事項解析結果_所有者ベース_${requestId}.csv`,
            });
            handleClose();
          }}
        >
          所有者ベースCSVダウンロード
        </MenuItem>
        <MenuItem
          onClick={() => {
            buttonClickHandler({
              requestId,
              resType: "csv_estates",
              fallBackName: `所有者事項解析結果_登記件数ベース_${requestId}.csv`,
            });
            handleClose();
          }}
        >
          登記件数ベースCSVダウンロード
        </MenuItem>
        <MenuItem
          onClick={() => {
            buttonClickHandler({
              requestId,
              resType: "excel_direct_mail",
              fallBackName: `DM対象者リスト（案）_${requestId}.xlsx`,
            });
            handleClose();
          }}
        >
          DM対象者リスト（案）
        </MenuItem>
      </Menu>
      <DmMaxBranchNumberModal
        open={openDmMaxBranchNumberModal}
        setOpen={setOpenDmMaxBranchNumberModal}
        requestId={realEstateOwnerAnalyzeRequestId}
        fallBackName={`DM対象者リスト（案）_${realEstateOwnerAnalyzeRequestId}.xlsx`}
      />
    </div>
  );
}
